
export default {
  name: 'PrivacyApp',
  nuxtI18n: {
    paths: {
      en: '/privacy-app',
      it: '/privacy-app',
      de: '/privacy-app'
    }
  },
  head() {
    return {
      title: 'Vitesy - Privacy App',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: `Privacy App`
        }
      ]
    }
  }
}
